
export function Home()
{
	return (
		<svg id="home" class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M53 59H36V45h-8v14H11V36H.2L32 4.2 63.8 36H53v23zm-13-4h9V32h5.2L32 9.8 9.8 32H15v23h9V41h16v14z"/></svg>
	);
}
